import React from "react";
import { Typography } from "@mui/material";
import SwaggerUI from "swagger-ui-react";
import SwaggerWrapper from "../../components/SwaggerWrapper";

const Geocoding = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Geocoding API
      </Typography>
      <Typography variant="body2">
        The Route Optimization API can be used to solve traveling salesman or vehicle routing
        problems. Solve your first problem by following these steps. If you already have a
        GraphHopper account, start with step 2.
      </Typography>
      <SwaggerWrapper>
        <SwaggerUI url="/swagger/geocoding.json" docExpansion="full" />
      </SwaggerWrapper>
    </>
  );
};

export default Geocoding;
